import { createReducer } from 'typesafe-actions';
import { createRoutineReducers, getInitialState } from '../common/utils/routine-reducer.js';
import { removeRoleRoutine, saveRoleRoutine, updateRoleRoutine } from './actions.js';

export const initialState = getInitialState({});

export default createReducer(initialState, {
  ...createRoutineReducers(saveRoleRoutine),
  ...createRoutineReducers(updateRoleRoutine),
  ...createRoutineReducers(removeRoleRoutine)
});
